import { useRef, useState, useEffect } from 'react';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';

import errorImage from '../../assets/images/error.png';

const useStyles = makeStyles((theme) => ({
  image: { width: '75vw', margin: '10px auto', objectFit: 'contain' },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  erorrDesc: {
    overflow: 'hidden',
    overflowY: 'auto',
    width: '80%',
  },
}));

const ErrorFallbackComponent = ({ error, resetErrorBoundary }) => {
  const classes = useStyles();
  const descRef = useRef(null);
  const [descHeight, setDescHeight] = useState(160);

  const calculateHeight = () => {
    let screenHeight = window.innerHeight;
    let offsetTop = descRef.current?.offsetTop;
    let newHeight = screenHeight - offsetTop - 95;
    setDescHeight(newHeight);
  };

  window.onresize = calculateHeight;

  useEffect(() => {
    if (null !== descRef.current) {
      calculateHeight();
    }
  }, [descRef.current?.offsetTop]);

  return (
    <Card sx={{ height: '100vh' }}>
      <CardMedia
        component='img'
        image={errorImage}
        height='45%'
        className={classes.image}
      />
      <CardContent className={classes.container}>
        <Typography variant='h4' component='h1' textAlign='center'>
          Something went wrong...
        </Typography>
        <Typography
          variant='subtitle1'
          component='p'
          className={classes.erorrDesc}
          textAlign='center'
          ref={descRef}
          sx={{ maxHeight: descHeight }}
        >
          (<b>Error:</b> {error?.message})
        </Typography>
      </CardContent>
      <CardActions sx={{ justifyContent: 'center' }}>
        <Button variant='contained' onClick={resetErrorBoundary}>
          Reload
        </Button>
      </CardActions>
    </Card>
  );
};

export default ErrorFallbackComponent;
